var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 529.6 467.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c1c1c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1188.55,609.82H731.38V345.55h457.17ZM742.62,598.57h434.69V356.79H742.62Z",
    transform: "translate(-695.1 -306.56)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "366.12 467.76 152.41 467.76 152.41 405.9 214.45 405.9 214.45 341.22 0 341.22 0 0 529.6 0 529.6 341.22 302.85 341.22 302.85 373.56 291.61 373.56 291.61 329.98 518.36 329.98 518.36 11.24 11.24 11.24 11.24 329.98 225.69 329.98 225.69 417.14 163.65 417.14 163.65 456.52 354.88 456.52 354.88 414.18 291.61 414.18 291.61 402.93 366.12 402.93 366.12 467.76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.871029c5c42eb6ff6aa05302fc24baa8.svg";
export { ForwardRef as ReactComponent };